import React from 'react'
import Accordion from '@material-ui/core/Accordion'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import { makeStyles } from '@material-ui/core/styles'
import styles from './vulner_collapse_card.module.css'
import CodeBox from '../../modules/code_box'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        borderBottom: "solid 1px rgba(17, 25, 42, 0.1)",
        /*   "&.MuiSvgIcon-root": {
              width:'24px',
              height:'24px'
          }, */
        "& .MuiAccordionSummary-content": {
            paddingTop: "1%",
            paddignBottom: "1%"
        },
        "& .MuiAccordionDetails-root": {
            fontSize: "14px",
            color: '#5b4182'
        },
        "& .MuiCollapse-container": {
            transition: "none !important"
        },
        "& .MuiAccordionSummary-content": {
            display: "block"
        }
    },
    heading: {
        fontWeight: 'bold',
        color: '#2e2744',
        fontSize: '14px'
    }
}))

export default function VulnerCollapseCard(props) {

    const classes = useStyles()
    let vulnerName = '',
        severityNum = 0,
        desc = '',
        arrayOfCodes = null,
        cwe,
        masvs,
        is_lib
    for (let key in props.data) {  //loop for array of data

        vulnerName = props.data[key].meta_data.title
        severityNum = props.data[key].meta_data.severity
        desc = props.data[key].meta_data.desc
        cwe = props.data[key].meta_data.cwe
        masvs = props.data[key].meta_data.masvs
        is_lib = props.data[key].meta_data.is_lib
        if (props.data[key].codes !== undefined)
            arrayOfCodes = props.data[key].codes
    }

    const codesHandler = (key, index) => {

        return (
            <div key={index}>
                <CodeBox
                    vulnerName={key} data={arrayOfCodes[key]}
                    is_lib={is_lib}
                    num={severityNum}
                />
            </div>
        )
    }

    const checkWariningColor = (num, is_lib) => {

        if (is_lib)
            return 'warning_blue'
        else if (num >= 4)
            return 'warning_red'

        return 'warning_yellow'
    }

    const iconContainerColorHandler = () => {
        if (is_lib)
            return 'bg-blue-200'
        else if (severityNum >= 4)
            return 'bg-red-200'
        else
            return 'bg-orange-200'
    }

    const serverityColorHandler = () => {
        if (is_lib)
            return 'text-blue-600 bg-blue-200'
        else if (severityNum >= 4)
            return 'text-red-600 bg-red-200'
        else
            return 'text-yellow-600 bg-orange-200'
    }

    const cweHandler = (cwe) => {
        window.open(`https://cwe.mitre.org/data/definitions/${cwe.split("-")[1]}.html`)
    }

    return (
        <div className={classes.root}>
            <Accordion elevation={0}>
                <AccordionSummary
                    expandIcon={<div className='px-1 bg-gray-200 rounded-lg'><ExpandMoreIcon /* className={classes.root} */ /></div>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <div className={styles.title_container}>
                        <div className={`${styles.icon_container} ${iconContainerColorHandler()} p-1 rounded-lg mt-1`}><img className={`${styles.warning_img}`} src={`/assets/icons/${checkWariningColor(severityNum, is_lib)}.svg`} alt="Warning" /></div>
                        <div className={`${styles.vulner_name} englishIranSans primary_color`}> {vulnerName}</div>
                        <div className={`${styles.severity_container} ${serverityColorHandler()}`}>{severityNum}</div>
                        {
                            cwe &&
                            <div onClick={() => cweHandler(cwe)} className={`${styles.cwe_container} englishIranSans`}>{cwe}</div>
                        }
                        {
                            masvs &&
                            <div className={`${styles.cwe_container} englishIranSans`}>{masvs}</div>
                        }
                    </div>
                </AccordionSummary>
                <div className={styles.vulner_card_content}>
                    <div className={styles.vulner_desc}>
                        <span className={styles.vulner_name_mobileMode}>{vulnerName}</span>
                        {desc}
                    </div>
                    {
                        (arrayOfCodes) &&
                        Object.keys(arrayOfCodes).map(codesHandler)
                    }

                </div>
            </Accordion>
        </div>
    )
}